module.exports = __webpack_public_path__ + "1881c69375fce5e8438037663a542392.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/bg.jpg
 ** module id = 59
 ** module chunks = 0
 **/